import {
  createContext,
  ReactElement,
  ReactNode,
  RefObject,
  useEffect,
  useRef,
  useState,
} from "react";
import { Flex, Box } from "@chakra-ui/react";
import { Footer } from "../atoms/CommonLayout/Footer";

/**
 * 画面全体ではなく内側の要素でスクロールするレイアウトが、その要素を渡す。
 * 無限スクロールは、この要素を基準に一覧の末尾が近づいたかを判定する
 */
export const ScrollContainerContext =
  createContext<RefObject<HTMLDivElement | null> | null>(null);

type BottomNavLayoutProps = {
  children: ReactNode;
};

export function BottomNavLayout({
  children,
}: Readonly<BottomNavLayoutProps>): ReactElement {
  const footerRef = useRef<HTMLDivElement>(null);
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [footerHeight, setFooterHeight] = useState(0);

  useEffect(() => {
    if (footerRef.current) {
      setFooterHeight(footerRef.current.offsetHeight);
    }
  }, []);

  return (
    <Flex h="full" minW="full" direction="column" justify="center">
      <Flex
        ref={scrollContainerRef}
        flex={1}
        direction="column"
        overflowY="auto"
        align="center"
        pb={`${footerHeight}px`}
      >
        <ScrollContainerContext.Provider value={scrollContainerRef}>
          {children}
        </ScrollContainerContext.Provider>
      </Flex>
      <Box
        ref={footerRef}
        position="fixed"
        bottom={0}
        left={0}
        right={0}
        zIndex={1000}
      >
        <Footer />
      </Box>
    </Flex>
  );
}
